'use server'

import { apiRequest, ApiResponse } from '../request'

export interface ProductCategoryItem {
    id: number
    name: string
    companyId: number
    isSubcategory: boolean
    parentId: number | null
    /** Imagem na loja (categorias em círculos, cards, menu). */
    image?: string | null
    parent?: {
        id: number
        name: string
    } | null
    subcategories?: ProductCategoryItem[]
    createdAt: string
    updatedAt: string
}

export async function getProductCategories(
    companyId?: number
): Promise<ApiResponse<ProductCategoryItem[]>> {
    return apiRequest<ProductCategoryItem[]>('product-categories', {
        params: companyId ? { companyId } : {},
    })
}

export async function getProductCategory(
    id: number
): Promise<ApiResponse<ProductCategoryItem>> {
    return apiRequest<ProductCategoryItem>(
        `product-categories/${id}`,
        {}
    )
}

export async function getProductCategoriesByCompany(
    companyId: number
): Promise<ApiResponse<ProductCategoryItem[]>> {
    return apiRequest<ProductCategoryItem[]>(
        `product-categories/company/${companyId}`,
        {}
    )
}

export async function getCategoriesOnlyByCompany(
    companyId: number
): Promise<ApiResponse<ProductCategoryItem[]>> {
    return apiRequest<ProductCategoryItem[]>(
        `product-categories/company/${companyId}/categories`,
        {}
    )
}

export async function getSubcategoriesByCompany(
    companyId: number
): Promise<ApiResponse<ProductCategoryItem[]>> {
    return apiRequest<ProductCategoryItem[]>(
        `product-categories/company/${companyId}/subcategories`,
        {}
    )
}

export async function getSubcategoriesByParent(
    parentId: number
): Promise<ApiResponse<ProductCategoryItem[]>> {
    return apiRequest<ProductCategoryItem[]>(
        `product-categories/${parentId}/subcategories`,
        {}
    )
}

export async function createProductCategory(data: {
    name: string
    companyId: number
    isSubcategory?: boolean
    parentId?: number
}): Promise<ApiResponse<ProductCategoryItem>> {
    return apiRequest<ProductCategoryItem>(
        'product-categories',
        { data },
        'post'
    )
}

export async function updateProductCategory(
    id: number,
    data: {
        name?: string
        isSubcategory?: boolean
        parentId?: number | null
    }
): Promise<ApiResponse<ProductCategoryItem>> {
    return apiRequest<ProductCategoryItem>(
        `product-categories/${id}`,
        { data },
        'patch'
    )
}

export async function deleteProductCategory(
    id: number
): Promise<ApiResponse<void>> {
    return apiRequest<void>(
        `product-categories/${id}`,
        {},
        'delete'
    )
}

/** Envia a imagem da categoria (até 5 MB; conta na cota de armazenamento). */
export async function uploadProductCategoryImage(
    id: number,
    file: File,
): Promise<ApiResponse<ProductCategoryItem>> {
    const formData = new FormData()
    formData.append('file', file)
    return apiRequest<ProductCategoryItem>(
        `product-categories/${id}/image`,
        { data: formData, formData: true },
        'post',
    )
}

export async function removeProductCategoryImage(id: number): Promise<ApiResponse<ProductCategoryItem>> {
    return apiRequest<ProductCategoryItem>(`product-categories/${id}/image`, {}, 'delete')
}
